// @utilities
import getProductsFromAggregatorData from './getProductsFromAggregatorData'

// @constants
const { CARDS } = require('constants/aggregator/products')

const getCardsFromAggregatorData = (immAggregatorData) => {
    const productList = getProductsFromAggregatorData(immAggregatorData)
    return productList.filter(product => product.product === CARDS)
}

export default getCardsFromAggregatorData;